<template>
  <div class="public-navbar">
    <v-toolbar v-resize="onResize" dark fixed app clipped-left
      :color="dark ? 'active-menu' : 'black'"
      :class="
        user != null && showPanelInv != false
          ? { [`pt-${isMobile ? 0 : 0}`]: true }
          : { [`pt-${isMobile ? 0 : 0}`]: true }
      "
    >
      <router-link to="/">
        <img class="rclogo" alt="RedCapital logo" style="padding-right: 20px;" src="images/prontoPago/logo_pp.png"/>
      </router-link>
      <!-- Menu Desk -->
      <v-toolbar-items v-if="!isMobile" style="width:100%"> 
        <v-btn class="font-OneRem" style="text-transform:none" to="/" flat>
          RedCapital.cl
        </v-btn>
        <v-spacer></v-spacer>
        <!-- <v-menu offset-y v-if="user == null"> -->
        <v-btn class="ml-2 " style="text-transform:capitalize;height: auto;padding: 5px 17px;font-size:1rem !important" outline round color="white" dark v-on="on" href="https://prontopago.redcapital.cl/login">
          Ingresar
        </v-btn>
        <v-btn class="ml-2 " style="text-transform:capitalize;height: auto;padding: 5px 17px;background: #ec6b1c !important;font-size:1rem !important" outline round color="white" dark v-on="on" href="https://prontopago.redcapital.cl/register">
          Registrarse
        </v-btn>
      </v-toolbar-items>
      <!-- Menu Movil -->
      <v-toolbar-side-icon v-if="isMobile" class="ml-auto" alt="Mostrar menu" aria-label="Menu" @click="showMenu = true"></v-toolbar-side-icon>
    </v-toolbar>
    <v-navigation-drawer v-model="showMenu"  right app fixed temporary>
      <v-list>
        <v-list-tile to="/">
          <v-list-tile-title>RedCapital.cl</v-list-tile-title>
        </v-list-tile>
        <v-list-tile href="https://prontopago.redcapital.cl/login">
          <v-list-tile-title>Ingresar</v-list-tile-title>
        </v-list-tile>
        <v-list-tile href="https://prontopago.redcapital.cl/register">
          <v-list-tile-title>Registrarse</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import {
  Menus,
  menu2,
  Profile,
  MyBusiness,
  MyDocuments,
} from "@/models/DashboardLinks";
import { EventBus } from "@/main";
import { RedCapital, RedCapitalConfig, SelectedCountry } from "@/configuration";

@Component({
  computed: {
    ...mapState(["user", "menu", "showPanelInv", "businesSelected"]),
    canShowLinks() {
      return (
        this.$route.path.startsWith("/panel/") ||
        this.$route.path.startsWith("/panel-facto/")
      );
    },
    projectsVisibility() {
      return (
        this.$store.state.user != null ||
        RedCapitalConfig(SelectedCountry).Project.PublicVisibility
      );
    },
    activeClass() {
      return "primary white--text";
    },
    accountType() {
      return this.$store.state.user.user_tipo_id == 2
        ? "investor"
        : "applicant";
    },
    urlimag() {
      return this.$store.state.menu == 2
        ? "/images/sitio-inversionista.png"
        : "/images/sitio-solicitante.png";
    },
    valroutesfacto(){
      return (
      this.$route.path.startsWith("/panel-facto/")
      )
    },
    userAnglo(){
      return (
        this.$store.state.user != null && this.$store.state.user.via_id == 2 ? true : false
      )
    }
  },
  data() {
    return {
      SelectedCountry,
      RedCapital,
      Menus,
      menu2,
      Profile,
      MyBusiness,
      MyDocuments,
      dark: true,
      canShowUserMenu: false,
      showMenu: false,
      isMobile: true,
      uglyLinks: [
        {
          to: "/quienes-somos",
          text: "Sobre nosotros",
        },
        {
          to: "/prensa",
          text: "En prensa",
        },
        {
          to: "/contacto",
          text: "Contacto",
        },
        {
          to: "/preguntas-frecuentes",
          text: "Preguntas frecuentes",
        },
        {
          to: "/garantia-riesgos",
          text: "Respaldos y riesgos",
        },
      ],
    };
  },
  methods: {
    panelInversionist() {
      this.$store.commit("setMenu", 2);
      this.$router.push("/panel/estadisticas");
     
    },
    panelFacture() {
      this.$store.commit("setMenu", 3);
       this.$router.push("/panel-facto/estadisticas");
    },
    onResize() {
      if (window.innerWidth <= 1270) { /* Old 1080 */ /* 960 Old */
        this.$data.isMobile = true;
      } else {
        this.$data.isMobile = false;
        this.$data.showMenu = false;
      }
    },
    login() {
      this.$data.showMenu = false;
      this.$data.canShowUserMenu = false;
      EventBus.$emit("open-login-dialog");
    },
    logout() {
      EventBus.$emit("logout");
    },
    goblog(){
      window.open("https://blog.redcapital.cl/", '_blank');
    },
    golog(){
      window.open("https://prontopago.redcapital.cl/login", '_blank');
    }
  },
})
export default class NavBar extends Vue {}
</script>

<style lang="scss" scoped>
.font-OneRem{
  font-size: 1rem !important;
  font-weight: 500 !important;
}
.navbar {
  z-index: 3;
}
.rclogo {
  @media (max-width: 960px) {
    height: 40px;
  }
  @media (min-width: 960px) {
    height: 50px;
  }
}
.invlogo {
  @media (max-width: 960px) {
    height: 20px;
  }
  @media (min-width: 960px) {
    height: 25px;
  }
}
.dis-none {
  @media (max-width: 600px) {
    display: none;
  }
}

.v-menu__content {
  position: fixed !important;
  border-radius: 1rem !important;
}
.active {
  box-shadow: 0px -2px 5px 0px rgb(195 87 14);
  //box-shadow: 4px 0 0px -2px #888;
  color: white;
  //border-radius: 0.325rem 0.325rem 0px 0px;
  border-radius: 15px 15px 0px 0px;
}
.btnsitio {
  background-color: #ecded4 !important;
  color: #c3570f;
  //border-radius: 0.325rem 0.325rem 0px 0px;
  border-radius: 15px 15px 0px 0px;
}
.active2 {
  //box-shadow: 0px -2px 5px 0px rgb(195 87 14);
  //box-shadow: 4px 0 0px -2px #888;
  color: white;
  //border-radius: 0.325rem 0.325rem 0px 0px;
}
.btnsitio2 {
  background-color: #ecded4 !important;
  color: #c3570f;
  //border-radius: 0.325rem 0.325rem 0px 0px;
}
.positionabs{
      position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: -36px;
    text-align: right;
    right: 0;
}

</style>
